import type { StateCreator } from "zustand";

export interface ThemeSlice {
  theme: Record<string, string> | null;
  setTheme: (theme: Record<string, string>) => void;
}

export const createThemeSlice: StateCreator<ThemeSlice> = (set) => ({
  theme: null,
  setTheme: (theme) => set({ theme }),
});
